<template>
  <anchor href="https://www.festfoods.com/">
    <template v-if="(!isHolidays && !isNotProduction) || (!previewHoliday && isNotProduction)">
      <img src="https://storage.googleapis.com/assets.festfoods.com/images/logo/header.svg" onerror="this.src='https://storage.googleapis.com/assets.festfoods.com/images/logo/header.png';this.onerror=null;" alt="Festival Foods">
    </template>
    <template v-else>
      <img v-if="isMobile" :src="logo.mobile" onerror="this.src='https://storage.googleapis.com/assets.festfoods.com/images/logo/header-white.png';this.onerror=null;" alt="Festival Foods">
      <img v-if="!isMobile" :src="logo.desktop" onerror="this.src='https://storage.googleapis.com/assets.festfoods.com/images/logo/header-white.png';this.onerror=null;" alt="Festival Foods">
    </template>
  </anchor>
</template>

<script>
import { mapGetters } from 'vuex'
import { WeeklyUpdatesContent } from '@/data/weekly-updates'

export default {
  computed: {
    ...mapGetters('window', [
      'isMobile'
    ]),
    isQA () {
      switch (true) {
        case (window.location.href.indexOf('qa') > -1):
          return true
        default:
          return false
      }
    },
    isHolidays () {
      return this.now >= this.$moment(new Date(this.runDates[0]['holiday'].start)).format() && this.now <= this.$moment(new Date(this.runDates[0]['holiday'].end)).format()
    },
    previewHoliday () {
      const now = this.$moment(new Date()).format()
      const start = this.$moment(new Date(this.runDates[0]['holiday'].previewStart)).format()
      const end = this.$moment(new Date(this.runDates[0]['holiday'].previewEnd)).format()
      if ((start <= now || this.isQA) && now <= end) {
        return true
      }
      return false
    },
    isNotProduction () {
      switch (true) {
        case (window.location.href.indexOf('qa') > -1):
          return true
        case (window.location.href.indexOf('localhost') > -1):
          return true
        default:
          return false
      }
    },
    logo () {
      switch (true) {
        case ((this.now >= this.$moment(new Date(this.runDates[0]['holiday'].thanksgivingEnd)).format() && (this.now <= this.$moment(new Date(this.runDates[0]['holiday'].end)).format() || this.now <= this.$moment(new Date(this.runDates[0]['holiday'].previewEnd)).format()))):
          return {
            mobile: 'https://storage.googleapis.com/assets.festfoods.com/images/logo/header-christmas-left.svg',
            desktop: 'https://storage.googleapis.com/assets.festfoods.com/images/logo/header-christmas.svg'
          }
        case ((this.now >= this.$moment(new Date(this.runDates[0]['holiday'].start)).format() || this.now <= this.$moment(new Date(this.runDates[0]['holiday'].previewStart)).format()) && this.now <= this.$moment(new Date(this.runDates[0]['holiday'].thanksgivingEnd)).format()):
          return {
            mobile: 'https://storage.googleapis.com/assets.festfoods.com/images/logo/header-thanksgiving-left.svg',
            desktop: 'https://storage.googleapis.com/assets.festfoods.com/images/logo/header-thanksgiving.svg'
          }
        default:
          return 'https://storage.googleapis.com/assets.festfoods.com/images/logo/header.svg'
      }
    }
  },
  data () {
    return {
      runDates: [...WeeklyUpdatesContent],
      now: this.$moment(new Date()).format()
    }
  },
  methods: {
    qa () {
      if (this.isQA) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss">
    .holiday-icon {
      @include breakpoint-max(md) {
        height: 3rem;
        width: auto;
      }
    }
    // .logo {
    //   a {
    //     display: flex;
    //   }
    // }
</style>
